(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter-reminder-button-counter/assets/javascripts/payfooter-reminder-button-counter-animations.js') >= 0) return;  svs.modules.push('/components/tur/payfooter-reminder-button-counter/assets/javascripts/payfooter-reminder-button-counter-animations.js');

'use strict';

function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
svs = svs || {};
svs.tur = svs.tur || {};
svs.tur.payfooter_reminder_button_counter = svs.tur.payfooter_reminder_button_counter || {};
var _element = new WeakMap();
var _amount = new WeakMap();
var _counterObj = new WeakMap();
var _updateCounterText = new WeakMap();
class PayfooterReminderAnimations {
  constructor(element, amount) {
    _classPrivateFieldInitSpec(this, _element, void 0);
    _classPrivateFieldInitSpec(this, _amount, void 0);
    _classPrivateFieldInitSpec(this, _counterObj, {
      val: 0
    });
    _classPrivateFieldInitSpec(this, _updateCounterText, () => {
      _classPrivateFieldGet(_amount, this).textContent = Math.floor(_classPrivateFieldGet(_counterObj, this).val);
    });
    _classPrivateFieldSet(_element, this, element);
    _classPrivateFieldSet(_amount, this, amount);
  }
  animateCounter(value) {
    return gsap.to(_classPrivateFieldGet(_counterObj, this), {
      val: value,
      duration: 1,
      ease: 'power1.out',
      onUpdate: _classPrivateFieldGet(_updateCounterText, this)
    });
  }
  buttonCounterUp() {
    return gsap.to(_classPrivateFieldGet(_element, this), {
      y: 0,
      opacity: 1
    });
  }
  buttonCounterDown() {
    return gsap.to(_classPrivateFieldGet(_element, this), {
      duration: 0.5,
      y: 100,
      delay: 0
    });
  }
}
svs.tur.payfooter_reminder_button_counter.animations = PayfooterReminderAnimations;

 })(window);